module.exports = __webpack_public_path__ + "img/myposition_wf_크리스티아누 호날두.8c81984f.png";